import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, CircularProgress, Grid } from '@mui/material';

import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { BackflowJobGroup } from '../../model';

import axios from '../../../sharedModules/utils/axios.utils';

interface WaterAuthorityMarkSubmittedButtonProps {
  backflowJobGroup: BackflowJobGroup;
}

const WaterAuthorityMarkSubmittedButton: React.FC<WaterAuthorityMarkSubmittedButtonProps> = ({ backflowJobGroup }) => {
  const history = useHistory();

  const [markingSubmitted, setMarkingSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const disableMarkAsSubmitted =
    markingSubmitted || !['approved', 'approved_with_error'].includes(backflowJobGroup.status);

  const buttonLabel = () => {
    if (markingSubmitted) return 'Marking...';
    if (backflowJobGroup?.status === 'submitted') return 'Submitted';
    return 'Mark Submitted';
  };

  const markAsSubmitted = async () => {
    setMarkingSubmitted(true);
    setErrorMessage('');
    try {
      await axios.put(`/backflows/backflow_job_groups/${backflowJobGroup.id}`, { status: 'submitted' });
      // Redirect to submissions list page after short delay to show success message
      setTimeout(() => {
        history.push('/backflow_tests/water_authority_submissions');
      }, 1500);
    } catch (err: any) {
      console.error(err);
      setErrorMessage('Failed to mark as submitted');
      setMarkingSubmitted(false);
    }
  };

  return (
    <Grid container>
      <Button
        variant="contained"
        color="success"
        startIcon={markingSubmitted ? <CircularProgress size={20} /> : <CheckCircleIcon />}
        onClick={markAsSubmitted}
        disabled={disableMarkAsSubmitted}
        fullWidth
        size="large"
        sx={{ py: 1.5 }}
      >
        {buttonLabel()}
      </Button>
      <ErrorMessage message={errorMessage} />
    </Grid>
  );
};

export default WaterAuthorityMarkSubmittedButton;
